import PaginationContainer from "../../../../../components/PaginationContainer";

const LicenseLogPagination = (props) => {
  const {
    description,
    filteredLicenseLogList,
    selectedPage,
    setSelectedPage,
    setSelectedPageLimit
  } = props;

  return (
    <div className="two-column-container two-column-container--has-margin">
      <div>
        {description()}
      </div>
      <div>
        <PaginationContainer
          marginTop={null}
          total={filteredLicenseLogList.length}
          onPageChange={setSelectedPage}
          isCurrentPageId={selectedPage}
          onEntryLimitChange={currentPageNum => {
            setSelectedPageLimit(currentPageNum);
            setSelectedPage(1);
          }}
        />
      </div>
    </div>
  );
}

export default LicenseLogPagination;
